import { useState, useEffect, useMemo, useLayoutEffect } from 'react';
import MotionLayout from '../../general/framer-motion/MotionLayout';

import GuideStyle from './GuideStyle';
import { Button } from 'antd';

const tutorialConstant =  {
    TUTORIAL_1: 0,
    TUTORIAL_2: 1,
    TUTORIAL_3: 2,
    TUTORIAL_4: 3,
    TUTORIAL_5: 4,
    TUTORIAL_6: 5,
    TUTORIAL_7: 6,
    TUTORIAL_8: 7,
    TUTORIAL_9: 8,
    TUTORIAL_10: 9,
    properties: {
        0:{key: 1, label: 'Personalizing Templates', link: 'https://www.utrade.com.my/u3/quickstart/UTRADE3-Web-Quickstart-Personalizing-Templates.mp4', thumbnail: require('./../../../images/Tutorial-video/logo.png')},
        1:{key: 2, label: 'Managing Templates', link: 'https://www.utrade.com.my/u3/quickstart/UTRADE3-Web-Quickstart-Managing-Templates.mp4', thumbnail: require('./../../../images/Tutorial-video/logo.png')},
        2:{key: 3, label: 'Creating Watchlists', link: 'https://www.utrade.com.my/u3/quickstart/UTRADE3-Web-Quickstart-Creating-Watchlists.mp4', thumbnail: require('./../../../images/Tutorial-video/logo.png')},
        3:{key: 4, label: 'Managing Watchlists', link: 'https://www.utrade.com.my/u3/quickstart/UTRADE3-Web-Quickstart-Managing-Watchlists.mp4', thumbnail: require('./../../../images/Tutorial-video/logo.png')},
        4:{key: 5, label: 'Personalizing Components', link: 'https://www.utrade.com.my/u3/quickstart/UTRADE3-Web-Quickstart-Personalizing-Components.mp4', thumbnail: require('./../../../images/Tutorial-video/logo.png')},
        5:{key: 6, label: 'Customizing Columns', link: 'https://www.utrade.com.my/u3/quickstart/UTRADE3-Web-Quickstart-Customizing-Columns.mp4', thumbnail: require('./../../../images/Tutorial-video/logo.png')},
        6:{key: 7, label: 'Placing Trades', link: 'https://www.utrade.com.my/u3/quickstart/UTRADE3-Web-Quickstart-Placing-Trades.mp4', thumbnail: require('./../../../images/Tutorial-video/logo.png')},
        7:{key: 8, label: 'Using Global Search', link: 'https://www.utrade.com.my/u3/quickstart/UTRADE3-Web-Quickstart-Global-Search.mp4', thumbnail: require('./../../../images/Tutorial-video/logo.png')},
        8:{key: 9, label: 'Setting Preferences', link: 'https://www.utrade.com.my/u3/quickstart/UTRADE3-Web-Quickstart-Setting-Preferences.mp4', thumbnail: require('./../../../images/Tutorial-video/logo.png')},
        9:{key: 10, label: 'Checking Order Status', link: 'https://www.utrade.com.my/u3/quickstart/UTRADE3-Web-Quickstart-Checking-Order-Status.mp4', thumbnail: require('./../../../images/Tutorial-video/logo.png')},
    }            
}

const Index = () => {
    const [videoLink, setVideoLink] = useState("");
    const [selectedVideo, setSelectedVideo] = useState("");
    const [selectedTitle, setSelectedTitle] = useState("");

    useEffect(() => {
        handleClick(tutorialConstant.properties[0]);
    }, []);
 

    const handleClick = (item:any) => {

        setVideoLink(item.link);
        setSelectedVideo(item.key);
        setSelectedTitle(item.label);
    }

    const handleOpenQuickStartGuide = () => {
        window.open('https://www.utrade.com.my/pdf/quickstart-utrade3.pdf', '_blank');
    }

 
    return (
        <MotionLayout>
    
            <GuideStyle  >
                {/* <div className='flex_container_title'>
                                <h2 className='text'>UTRADE 3 Web Quickstart</h2>
                    </div> */}
                    <div className='pt-3'></div>
                    <div className="flex_container_row">
                        <div className='flex_container tutorialList pt-3'>
                            <div className='flex_container tutorialList'>
                                {Object.values(tutorialConstant.properties).map(index => {
                                    let classes = selectedVideo === index.key ? 'videoList selected' : 'videoList';
                                    return <span className={classes} onClick={() => handleClick(index)}  key={index.key}>
                                        <img src={index.thumbnail} key={index.key} className="logo_item" alt="logo" />
                                        <p className='videoListLabel'>{index.label}</p>
                                    </span>
                                })}
                            </div>
                        </div>
                        <div className='flex_container tutorialContent'>
                            <div className=' tutorialContent'>
                                <div className='p-2'>
                                <Button type='link' onClick={()=>handleOpenQuickStartGuide()} style={{color:"black"}}><small><u>View UTRADE 3 Quickstart Guide [PDF]</u> </small></Button>
                              
                                <h1 className='selectedTutorialLabel'>{selectedTitle}</h1>
                                <div className='pt-2'></div>
                                {
                                    videoLink &&
                                    <video className="video-iframe" style={{ width: '80%', height: '75%' }} controls key={videoLink}>
                                        <source src={videoLink} type="video/mp4" />
                                    </video>
                                }


                                </div>
                            </div>
                        </div>
                </div>
            </GuideStyle>
        
        </MotionLayout>
    );
};

export default Index;


  
